"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export const FixedContactButton = () => {
  const pathname = usePathname();

  if (pathname === "/contact" || pathname === "/contact/") {
    return null;
  }

  return (
		<Link
			href='/contact/'
			className='max-md:hidden fixed right-0 top-[40%] bg-[#E4A43E] px-6 py-4 rounded-l-[20px] z-[999] text-black hover:bg-[#5E6A79] hover:text-white no-underline leading-[125%] hover:bg-gray-800 transition-colors duration-200'
		>
			CONTACT US
		</Link>
	)
};

